<template>

    <div id="project-application-component">

        <div class="row">
            <div class="col-xs-12 col-md-8 mb-4">
                <select v-model="selected_project_id" class="form-control">

                    <option value="">프로젝트를 선택하세요</option>
                    <option v-for="project in projects"
                            :value="project.id"
                            v-text="project.title"></option>

                </select>
            </div>
            <div class="col-xs-12 col-md-4 mb-4">
                <div class="btn-group btn-group-justified" role="group" aria-label="...">
                    <div class="btn-group" role="group">
                        <button type="button" class="btn btn-default" @click.prevent="reset">초기화</button>
                    </div>
                    <div class="btn-group" role="group">
                        <button type="button" class="btn btn-primary"
                                data-updating-text="저장중..."
                                data-updated-text="저장되었습니다."
                                data-fail-text="실패하였습니다." @click.prevent="updateApplicants($event)">저장
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 mt-8">
                <div class="text-right">
                    현재 날짜: <span class="font-bold text-blue">{{ current }}</span>
                </div>
                <table v-if="project" class="table table-bordered">
                    <thead>
                    <tr>
                        <th>모집 시작일</th>
                        <th>모집 종료일</th>
                        <th>테스트 시작일</th>
                        <th>테스트 종료일</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>{{ project.application_start | moment_format_LL }}</td>
                        <td>{{ project.application_end | moment_format_LL }}</td>
                        <td>{{ project.testing_start | moment_format_LL }}</td>
                        <td>{{ project.testing_end | moment_format_LL }}</td>
                    </tr>
                    </tbody>
                </table>
                <div v-else class="panel panel-default">
                    <div class="panel-body text-center">
                        프로젝트 스케줄 정보
                    </div>
                </div>
            </div>
            <div class="col-xs-12">
                <div class="panel panel-default">
                    <div class="panel-heading">전문 테스터 선발</div>
                    <div class="panel-body">

                        <div class="row">
                            <div class="col-xs-12 col-md-4">

                                <div class="applicant-information" v-if="opened_expert_applicant_section">
                                    <div class="panel panel-default">
                                        <div class="panel-heading clearfix">
                                            {{ selected_expert_applicant.mb_id }}
                                            <button class="btn btn-xs btn-warning float-right"
                                                    @click="opened_expert_applicant_section = false">닫기
                                            </button>
                                        </div>
                                        <div class="panel-body overflow-y-scroll" style="height: 650px;">

                                            <dl>
                                                <dt>이름</dt>
                                                <dd>{{ selected_expert_applicant.mb_name }}</dd>
                                                <dt>가입일</dt>
                                                <dd>{{ selected_expert_applicant.mb_datetime | moment_format_LL }}</dd>
                                                <dt>주소</dt>
                                                <dd>{{ selected_expert_applicant.mb_addr1 + " " + selected_expert_applicant.mb_addr2 }}
                                                </dd>
                                                <dt>자격증</dt>
                                                <dd>{{ selected_expert_applicant.mb_it_certificate }}</dd>
                                                <dt>테스트 경험여부</dt>
                                                <dd>{{ selected_expert_applicant.mb_testing_experience == "true" ? "있음" : "없음"
                                                    }}
                                                </dd>
                                                <dt>테스터 경험횟수</dt>
                                                <dd>{{ getPassedCountOfApplicant(selected_expert_applicant) }}</dd>

                                                <dt>지원이유</dt>
                                                <dd>{{ selected_expert_applicant.application_reason || "내용 없음" }}</dd>
                                                <dt>테스트 신청일</dt>
                                                <dd>{{ selected_expert_applicant.application_created_at |
                                                    moment_format_LLL }}
                                                </dd>
                                            </dl>

                                        </div>
                                    </div>
                                </div>

                                <div v-else>
                                    <div class="text-right border-b">
                                        <span class="text-3xl font-bold text-blue">{{ passed_expert_applicants.length }}</span>
                                        / {{ project
                                        ? project.expert_tester : 0 }}
                                    </div>

                                    <ul class="list-group mt-4">
                                        <li v-for="mb_no in passed_expert_applicants" class="list-group-item">
                      <span class="badge" @click.prevent="removePassedExpertApplicant(mb_no)"><span
                              class="glyphicon glyphicon-remove"></span></span>
                                            {{ getApplicant(mb_no).mb_id }}
                                        </li>
                                    </ul>
                                </div>


                            </div>
                            <div class="col-xs-12 col-md-8 border-l">

                                <div class="text-right border-b" style="line-height: 43px">
                                    <span class="float-left text-red-light">* 아래표의 해더를 클릭할 경우 해당 해더 항목으로 정렬 가능</span>
                                    <span class="text-3xl font-bold text-blue">{{ passed_expert_applicants.length }}</span>
                                    / {{
                                    expert_tester_applicants.length }}
                                </div>

                                <table class="table table-bordered mt-4 expert-applicants">
                                    <thead>
                                    <tr>
                                        <!--<th width="20"><input type="checkbox"></th>-->
                                        <th width="20"></th>
                                        <th @click="orderExpert('mb_id')">
                                            <span v-if="order_expert.key == 'mb_id' && order_expert.value > 0" class="glyphicon glyphicon-chevron-down"></span>
                                            <span v-if="order_expert.key == 'mb_id' && order_expert.value < 0" class="glyphicon glyphicon-chevron-up"></span>
                                            ID
                                        </th>
                                        <th @click="orderExpert('mb_name')">
                                            <span v-if="order_expert.key == 'mb_name' && order_expert.value > 0" class="glyphicon glyphicon-chevron-down"></span>
                                            <span v-if="order_expert.key == 'mb_name' && order_expert.value < 0" class="glyphicon glyphicon-chevron-up"></span>
                                            이름
                                        </th>
                                        <th>자격증</th>
                                        <th @click="orderExpert('mb_testing_experience')">
                                            <span v-if="order_expert.key == 'mb_testing_experience' && order_expert.value > 0" class="glyphicon glyphicon-chevron-down"></span>
                                            <span v-if="order_expert.key == 'mb_testing_experience' && order_expert.value < 0" class="glyphicon glyphicon-chevron-up"></span>
                                            테스트 경험여부
                                        </th>
                                        <th @click="orderExpert('passed_count')">
                                            <span v-if="order_expert.key == 'passed_count' && order_expert.value > 0" class="glyphicon glyphicon-chevron-down"></span>
                                            <span v-if="order_expert.key == 'passed_count' && order_expert.value < 0" class="glyphicon glyphicon-chevron-up"></span>
                                            테스트 참여횟수
                                        </th>
                                        <th @click="orderExpert('application_created_at')">
                                            <span v-if="order_expert.key == 'application_created_at' && order_expert.value > 0" class="glyphicon glyphicon-chevron-down"></span>
                                            <span v-if="order_expert.key == 'application_created_at' && order_expert.value < 0" class="glyphicon glyphicon-chevron-up"></span>
                                            테스트 신청일
                                        </th>
                                        <th>상세보기</th>

                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="applicant in expert_tester_applicants">
                                        <td><input v-model="passed_expert_applicants" :value="applicant.mb_no"
                                                   type="checkbox"></td>
                                        <td>{{ applicant.mb_id }}</td>
                                        <td>{{ applicant.mb_name }}</td>
                                        <td>{{ applicant.mb_it_certificate }}</td>
                                        <td>{{ applicant.mb_testing_experience == "true" ? "있음" : "없음" }}</td>
                                        <td>{{ getPassedCountOfApplicant(applicant) }}</td>
                                        <td>{{ applicant.application_created_at | moment_format_LLL }}</td>
                                        <td>
                                            <button @click="onClickExpertApplicantDetail(applicant)"
                                                    class="btn btn-default">상세보기
                                            </button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-xs-12">
                <div class="panel panel-default">
                    <div class="panel-heading">일반 테스터 선발</div>
                    <div class="panel-body">

                        <div class="row">
                            <div class="col-xs-12 col-md-4">

                                <div class="applicant-information" v-if="opened_normal_applicant_section">

                                    <div class="panel panel-default">
                                        <div class="panel-heading clearfix">
                                            {{ selected_normal_applicant.mb_id }}
                                            <button class="btn btn-xs btn-warning float-right"
                                                    @click="opened_normal_applicant_section = false">닫기
                                            </button>
                                        </div>
                                        <div class="panel-body overflow-y-scroll">

                                            <dl>
                                                <dt>이름</dt>
                                                <dd>{{ selected_normal_applicant.mb_name }}</dd>
                                                <dt>가입일</dt>
                                                <dd>{{ selected_normal_applicant.mb_datetime | moment_format_LL }}</dd>
                                                <dt>주소</dt>
                                                <dd>{{ selected_normal_applicant.mb_addr1 + " " + selected_normal_applicant.mb_addr2 }}
                                                </dd>
                                                <dt>자격증</dt>
                                                <dd>{{ selected_normal_applicant.mb_it_certificate }}</dd>
                                                <dt>테스트 경험여부</dt>
                                                <dd>{{ selected_normal_applicant.mb_testing_experience == "true" ? "있음" : "없음" }}
                                                </dd>
                                                <dt>테스터 경험횟수</dt>
                                                <dd>{{ getPassedCountOfApplicant(selected_normal_applicant) }}</dd>
                                                <dt>지원이유</dt>
                                                <dd>{{ selected_normal_applicant.application_reason || "내용 없음"  }}</dd>
                                                <dt>테스트 신청일</dt>
                                                <dd>{{ selected_normal_applicant.application_created_at |
                                                    moment_format_LLL }}
                                                </dd>
                                            </dl>

                                        </div>
                                        <div class="panel-footer">

                                            <device v-for="device in selected_normal_applicant.devices" :device-id="device.id" readonly="true"></device>

                                        </div>
                                    </div>

                                </div>

                                <div v-else>
                                    <div class="text-right border-b">
                                        <span class="text-3xl font-bold text-blue">{{ passed_normal_applicants.length }}</span>
                                        / {{ project
                                        ? project.normal_tester : 0 }}
                                    </div>

                                    <ul class="list-group mt-4">
                                        <li v-for="mb_no in passed_normal_applicants" class="list-group-item">
                      <span class="badge" @click.prevent="removePassedNormalApplicant(mb_no)"><span
                              class="glyphicon glyphicon-remove"></span></span>
                                            {{ getApplicant(mb_no).mb_id }}
                                        </li>
                                    </ul>
                                </div>


                            </div>
                            <div class="col-xs-12 col-md-8 border-l">

                                <div class="text-right border-b" style="line-height: 43px">
                                    <span class="float-left text-red-light">* 아래표의 해더를 클릭할 경우 해당 해더 항목으로 정렬 가능</span>
                                    <span class="text-3xl font-bold text-blue">{{ passed_normal_applicants.length }}</span>
                                    / {{ normal_tester_applicants.length }}
                                </div>

                                <table class="table table-bordered mt-4 normal-applicants">
                                    <thead>
                                    <tr>
                                        <!--<th width="20"><input type="checkbox"></th>-->
                                        <th width="20"></th>
                                        <th @click="orderNormal('mb_id')">
                                            <span v-if="order_normal.key == 'mb_id' && order_normal.value > 0" class="glyphicon glyphicon-chevron-down"></span>
                                            <span v-if="order_normal.key == 'mb_id' && order_normal.value < 0" class="glyphicon glyphicon-chevron-up"></span>
                                            ID
                                        </th>
                                        <th @click="orderNormal('mb_name')">
                                            <span v-if="order_normal.key == 'mb_name' && order_normal.value > 0" class="glyphicon glyphicon-chevron-down"></span>
                                            <span v-if="order_normal.key == 'mb_name' && order_normal.value < 0" class="glyphicon glyphicon-chevron-up"></span>
                                            이름
                                        </th>
                                        <th>자격증</th>
                                        <th @click="orderNormal('mb_testing_experience')">
                                            <span v-if="order_normal.key == 'mb_testing_experience' && order_normal.value > 0" class="glyphicon glyphicon-chevron-down"></span>
                                            <span v-if="order_normal.key == 'mb_testing_experience' && order_normal.value < 0" class="glyphicon glyphicon-chevron-up"></span>
                                            테스트 경험여부
                                        </th>
                                        <th @click="orderNormal('passed_count')">
                                            <span v-if="order_normal.key == 'passed_count' && order_normal.value > 0" class="glyphicon glyphicon-chevron-down"></span>
                                            <span v-if="order_normal.key == 'passed_count' && order_normal.value < 0" class="glyphicon glyphicon-chevron-up"></span>
                                            테스트 참여횟수
                                        </th>
                                        <th @click="orderNormal('application_created_at')">
                                            <span v-if="order_normal.key == 'application_created_at' && order_normal.value > 0" class="glyphicon glyphicon-chevron-down"></span>
                                            <span v-if="order_normal.key == 'application_created_at' && order_normal.value < 0" class="glyphicon glyphicon-chevron-up"></span>
                                            테스트 신청일
                                        </th>
                                        <th>상세보기</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="applicant in normal_tester_applicants">
                                        <td><input v-model="passed_normal_applicants" :value="applicant.mb_no"
                                                   type="checkbox"></td>
                                        <td>{{ applicant.mb_id }}</td>
                                        <td>{{ applicant.mb_name }}</td>
                                        <td>{{ applicant.mb_it_certificate }}</td>
                                        <td>{{ applicant.mb_testing_experience == "true" ? "있음" : "없음" }}</td>
                                        <td>{{ getPassedCountOfApplicant(applicant) }}</td>
                                        <td>{{ applicant.application_created_at | moment_format_LLL }}</td>
                                        <td>
                                            <button @click="onClickNormalApplicantDetail(applicant)"
                                                    class="btn btn-default">상세보기
                                            </button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    import moment from 'moment';
    import User from './User';

    export default {
        name: "project-application",
        components: {
            'user': User,
        },
        props: [
            'companyId', // 기업 아이디
        ],
        data() {
            return {
                // 초기 기본 데이터
                data: {
                    // 프로젝트들
                    projects: [],
                    // 지원자들
                    applicants: [],
                },
                // 관련 기업 아이디
                company_id: "",
                // 선택된 프로젝트 아이디
                selected_project_id: "",
                // 선택된 전문 지원자 아이디
                selected_expert_applicant_id: "",
                // 전문 지원자 상세정보 섹션의 노출 여부
                opened_expert_applicant_section: false,
                // 선택된 일반 지원자 아이디
                selected_normal_applicant_id: "",
                // 일반 지원자 상세정보 섹션의 노출 여부
                opened_normal_applicant_section: false,
                // 선발된 전문 테스터들
                passed_normal_applicants: [],
                // 선발된 일반 테스터들
                passed_expert_applicants: [],
                order_expert: {
                    key: "", value: ""
                },
                order_normal: {
                    key: "", value: ""
                }
            }
        },
        created() {

            this.company_id = this.companyId;

            this.getData();

        },
        watch: {
            selected_project_id(new_id, old_id) {
                if (isNaN(new_id)) return;

                this.setPassedApplicants();
            },
            order_normal: {
                handler: function(new_order, old_order) {
                    this.$forceUpdate();
                },
                deep: true
            },
            order_expert: {
                handler: function(new_order, old_order) {
                    this.$forceUpdate();
                },
                deep: true
            }
        },
        computed: {
            // 선발 단계에 있는 모든 프로젝트들
            projects() {
                return this.data.projects;
            },
            // 선택된 프로젝트
            project() {
                return _.filter(this.projects, (project) => {
                    return project.id == this.selected_project_id
                })[0]
            },
            // 선택된 프로젝트의 테스터들
            applicants() {
                let filtered_applicants = _.filter(this.data.applicants, (applicant) => {
                    return applicant.project_id == this.selected_project_id
                })

                filtered_applicants = _.map(filtered_applicants, (applicant) => {
                    applicant.passed_count = this.getPassedCountOfApplicant(applicant)
                    return applicant;
                });

                return filtered_applicants;
            },
            // 상세보기로 선택된 전문 지원자
            selected_expert_applicant() {
                return _.filter(this.data.applicants, (applicant) => {
                    return (applicant.mb_no == this.selected_expert_applicant_id && applicant.project_id == this.selected_project_id )
                })[0]
            },
            // 상세보기로 선택된 일반 지원자
            selected_normal_applicant() {
                return _.filter(this.data.applicants, (applicant) => {
                    return (applicant.mb_no == this.selected_normal_applicant_id && applicant.project_id == this.selected_project_id )
                })[0]
            },
            // 선택된 프로젝트의 전문 테스터들
            expert_tester_applicants() {

                let filtered_applicants = _.filter(this.applicants, (applicant) => {
                    return applicant.mb_tester_type == "expert"
                })

                let order_by_key = [];
                let order_by_value = [];

                if (this.order_expert.key != "") {
                    order_by_key.push(this.order_expert.key)
                    order_by_value.push(this.order_expert.value > 0 ? "asc" : "desc")
                }

                let ordered_applicants = _.orderBy(filtered_applicants, order_by_key, order_by_value)
                return ordered_applicants;
            },
            // 선택된 프로젝트의 일반 테스터들
            normal_tester_applicants() {

                let filtered_applicants = _.filter(this.applicants, (applicant) => {
                    return applicant.mb_tester_type == "normal"
                })

                let order_by_key = [];
                let order_by_value = [];

                if (this.order_normal.key != "") {
                    order_by_key.push(this.order_normal.key)
                    order_by_value.push(this.order_normal.value > 0 ? "asc" : "desc")
                }

                let ordered_applicants = _.orderBy(filtered_applicants, order_by_key, order_by_value)
                return ordered_applicants;
            },
            passed_applicants() {
                return _.concat(this.passed_normal_applicants, this.passed_expert_applicants);
            },
            // 현재 날짜 정보
            current() {
                return moment().format('LLL');
            }
        },
        methods: {
            // 선발 가능한 프로젝트 목록과 해당 프로젝트에 지원한 테스터 정보를 가지고 온다.
            getData() {

                $.ajax({
                    url: "/company/" + this.company_id + "/application",
                    methods: 'get'
                }).done((response) => {
                    this.data = response;
                })

            },
            updateApplicants($event) {

                $($event.target).button('updating');

                if (this.selected_project_id == "") {
                    $($event.target).button('fail');
                    setTimeout(() => {
                        $($event.target).button('reset')
                    }, 1000)
                    return;
                }
                ;

                $.ajax({
                    url: "/project/" + this.selected_project_id + "/application",
                    methods: "post",
                    data: {_method: "put", passed_applicants: this.passed_applicants}
                }).done((response) => {
                    $($event.target).button('updated');

                    setTimeout(() => {
                        $($event.target).button('reset')
                    }, 1000)
                })

            },
            onClickExpertApplicantDetail(applicant) {
                this.opened_expert_applicant_section = true;
                this.selected_expert_applicant_id = applicant.mb_no;
            },
            onClickNormalApplicantDetail(applicant) {
                this.opened_normal_applicant_section = true;
                this.selected_normal_applicant_id = applicant.mb_no;
            },
            getApplicant(mb_no) {
                return _.filter(this.applicants, (applicant) => {
                    return applicant.mb_no == mb_no;
                })[0]
            },
            removePassedExpertApplicant(mb_no) {
                this.passed_expert_applicants.splice(this.passed_expert_applicants.indexOf(mb_no), 1);
            },
            removePassedNormalApplicant(mb_no) {
                this.passed_normal_applicants.splice(this.passed_normal_applicants.indexOf(mb_no), 1);
            },
            setPassedApplicants() {
                let filtered_passed_expert_applicants = _.filter(this.expert_tester_applicants, (applicant) => {
                    return applicant.application_status == "pass"
                });
                let filtered_passed_normal_applicants = _.filter(this.normal_tester_applicants, (applicant) => {
                    return applicant.application_status == "pass"
                });

                this.passed_expert_applicants = _.reduce(filtered_passed_expert_applicants, (result, value, key) => {
                    result.push(value.mb_no);
                    return result;
                }, [])
                this.passed_normal_applicants = _.reduce(filtered_passed_normal_applicants, (result, value, key) => {
                    result.push(value.mb_no);
                    return result;
                }, [])
            },
            reset() {
                this.setPassedApplicants();
            },
            getPassedCountOfApplicant(applicant) {
                let records = _.filter(this.data.passed_record, (record) => {
                    return record.mb_no == applicant.mb_no && this.selected_project_id != record.project_id;
                })
                return records.length;
            },
            orderExpert(key) {
                if (this.order_expert.key == "" || this.order_expert.key != key) {
                    this.order_expert.key = key;
                    this.order_expert.value = 1;
                } else if (this.order_expert.key == key) {
                    this.order_expert.value *= -1;
                }
            },
            orderNormal(key) {
                if (this.order_normal.key == "" || this.order_normal.key != key) {
                    this.order_normal.key = key;
                    this.order_normal.value = 1;
                } else if (this.order_normal.key == key) {
                    this.order_normal.value *= -1;
                }
            }
        }
    }

</script>

<style lang="scss" scoped>

    #project-application-component {
        font-size: 14px;
    }

    .applicant-information {
        dt {
            margin-bottom: 0.5em;
        }
        dd {
            margin-bottom: 1em;
            padding-bottom: 1em;
            border-bottom: 1px solid #eee;
        }
    }

    .badge {
        cursor: pointer;
    }
    
    .normal-applicants, .expert-applicants {
        th {
            cursor: pointer;
        }
    }

    .applicant-information {
        height: 680px;
        overflow-y: scroll;
        border: 1px solid #ccc;
        padding: 0.5em;

        .panel-footer {
            background-color: #fcfcfc;
        }
    }

</style>



// WEBPACK FOOTER //
// src/ProjectApplication.vue